<template>
    <div class="intelligent_edit" v-loading.fullscreen="isLoading" element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.6)">
        <div class="intelligent_edit_container">
            <div id="left" class="edit_left">
                <div class="edit_left_paper">
                    <div class="paper_container" :style="{height: lineTipShowArr[lineTipShowArr.length-1] + 'px'}">
                        <div id="paper">
                            <template v-for="(item, index) in questionShowList">
                                <title-question v-if="item.questionType === 1"
                                                :style="{marginTop: item.marginTop + 'px'}"
                                                :question="item" :key="index"></title-question>
                                <select-question v-if="item.questionType === 2"
                                                 :style="{marginTop: item.marginTop + 'px'}"
                                                 :question="item" :key="index"></select-question>
                                <blank-question v-if="item.questionType === 3"
                                                :style="{marginTop: item.marginTop + 'px'}"
                                                :question="item" :key="index"></blank-question>
                                <answer-question v-if="item.questionType === 4"
                                                 :style="{marginTop: item.marginTop + 'px'}"
                                                 :question="item" :key="index"></answer-question>
                            </template>
                        </div>
                    </div>
                </div>
                <template v-for="(item, index) in lineTipShowArr">
                    <div v-if="index !== lineTipShowArr.length - 1" :key="index" :style="{top: item / 10 * 7 + 'px'}" class="page_line">
                        <span>{{pageLineText(index)}}</span>
                    </div>
                </template>
            </div>
            <div id="right" class="edit_right">
                <right-head :info="titleInfo" :id="constructId" @mainChange="sumSmallOrder"></right-head>
                <template v-for="(item, index) in questionShowList">
                    <right-question :question="item"
                                    :key="index"
                                    @addTitle="addTitleQuestionTop(index)"
                                    @merge="mergeLastQuestion(index)"
                                    @detail="showQuestionDetail(item, index)"></right-question>
                </template>
            </div>
        </div>
        <div class="intelligent_edit_foot">
            <div class="edit_foot">
                <div>
                    总分：{{totalScore}}&emsp;题目数量：{{totalNumber}}
                </div>
                <div class="btn_bar">
                    <button class="btn" @click="savePaper">保存</button>
                    <button class="btn download" @click="downPaper">下载</button>
                </div>
            </div>
        </div>
        <question-setting v-model="detailDialog"
                          :numbering="titleInfo.numbering"
                          @split="splitQuestion"
                          @mainChange="sumSmallOrder"
                          :question="activeQuestionSet"></question-setting>
    </div>
</template>

<script>
    import html2canvas from 'html2canvas'
    import AnswerQuestion from './components/draw/AnswerQuestion'
    export default {
        name: "IntelligentEdit",
        components: {
            RightHead: () => import('./components/edit/RightHead'),
            RightQuestion: () => import('./components/edit/RightQuestion'),
            QuestionSetting: () => import('./components/edit/QuestionSetting'),
            TitleQuestion: () => import('./components/draw/TitleQuestion'),
            SelectQuestion: () => import('./components/draw/SelectQuestion'),
            AnswerQuestion,
            BlankQuestion: () => import('./components/draw/BlankQuestion')
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.$store.dispatch('contextHead', false);
            });
        },
        beforeRouteLeave (to, from, next) {
            this.$store.dispatch('contextHead', true);
            next()
        },
        data () {
            return {
                timeout: null,
                isLoading: false,
                detailDialog: false,
                lineTipArr: [], // 分页提示每一页高度数组
                needAddLineIndex: [],// 需要后端补线的下标数组
                constructId: '577130666222784512', // 组卷id
                constructInfo: {}, // 组卷信息
                titleInfo: {}, // 组卷头部信息
                activeQuestion: {},
                activeQuestionIndex: 0,
                questionShowList: [],
                isJudge: true
            }
        },
        created () {
            if (this.$route.query.id) {
                this.constructId = this.$route.query.id;
            } else {
                this.$notify.error({
                    title: '提示',
                    message: '缺少组卷信息，请检查重试',
                    offset: 50
                });
                // return
            }
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.getConstructDetail();
        },
        beforeDestroy () {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
        },
        computed: {
            // 总分
            totalScore () {
                let scoreArr = [];
                this.questionShowList.forEach(item => {
                    if (item.questionType !== 1) {
                        let scores = item.detail.map(detail => detail.questionValue);
                        scoreArr.push(scores.reduce((x, y) => x + y))
                    }
                });
                return scoreArr.length && scoreArr.reduce((x, y) => x + y) || 0
            },
            // 题目数量
            totalNumber () {
                let total = 0;
                this.questionShowList.forEach(item => {
                    if (item.questionType !== 1) {
                        let arr = item.detail.map(item => !item.hasChildren);
                        total += arr.length;
                    }
                });
                return total
            },
            // 详情题目
            activeQuestionSet () {
              return this.questionShowList[this.activeQuestionIndex];
            },
            // 分页提示线坐标
            lineTipShowArr () {
                let arr = [];
                let list = JSON.parse(JSON.stringify(this.lineTipArr));
                list.forEach((item,index) => {
                    if (index === 0) {
                        arr.push(item)
                    } else {
                        let total = list.slice(0,index + 1).reduce((pre, cur) => pre + cur);
                        arr.push(total)
                    }
                });
                console.log(arr);
                return arr
            },
            // 右侧头部设置修改
            titleSetChange () {
                return [this.titleInfo.paperSize, this.titleInfo.isBinding]
            },
            // 题目变化 json 字符串
            questionListChange () {
                return JSON.stringify(this.questionShowList)
            },
            // 大题数量 题型变化
            questionTypeNum () {
                let list = this.questionShowList.filter(item => item.questionType !== 1);
                return list.map(item => item.questionType).join('')
            }
        },
        watch: {
            questionListChange: {
                handler () {
                    this.$nextTick(() => {
                        this.debounce()
                    })
                }
            },
            // 右侧头部设置
            titleSetChange () {
                this.$nextTick(() => {
                    this.debounce()
                })
            },
            // 大题题型数量变化 计算题号范围
            questionTypeNum () {
                this.sumSmallOrder()
            }
        },
        methods: {
            pageLineText (index) {
                if (this.titleInfo.paperSize) {
                    return `第${index + 1}页`
                } else {
                    return `第${Math.ceil((index + 1) / 2)}页${(index + 1) % 2 === 0 ? '右侧' : '左侧'}`;
                }
            },
            // 防抖
            debounce() {
                if(this.timeout !== null)   clearTimeout(this.timeout);
                this.timeout = null;
                this.timeout = setTimeout(() => {
                    this.sumPaperHeight();
                }, 300)
            },
            // 统计内容高度
            sumPaperHeight () {
                const totalHeight = document.getElementById('paper').offsetHeight;
                let height = totalHeight;
                this.lineTipArr = [];
                while (height > 0) {
                    if (this.lineTipArr.length === 0) {
                        let value = 1670 - (this.titleInfo.isBinding ? 292 : 322);
                        height -= value;
                        this.lineTipArr.push(value)
                    }else if (this.titleInfo.paperSize) {
                        if ((this.lineTipArr.length + 1) % 2 === 0) {
                            let value = 1670 - 132;
                            height -= value;
                            this.lineTipArr.push(value);
                        } else {
                            let value = 1670 - 282;
                            height -= value;
                            this.lineTipArr.push(value);
                        }
                    } else {
                        if ((this.lineTipArr.length + 1) % 4 === 1) {
                            let value = 1670 - 282;
                            height -= value;
                            this.lineTipArr.push(value);
                        } else {
                            let value = 1670 - 132;
                            height -= value;
                            this.lineTipArr.push(value);
                        }
                    }
                }
                this.$nextTick(() => {
                    this.sumQuestionPadding();
                });
            },
            // 给题型添加marginTop 分页
            sumQuestionPadding () {
                let list = JSON.parse(JSON.stringify(this.questionShowList));
                let pageHeight = JSON.parse(JSON.stringify(this.lineTipArr));
                console.log(list, 'marginTop分页');
                let needAddLineIndex = [];
                let lineTotal = 0;
                list.forEach(item => {
                    item.marginTop = 0;
                    if (item.height <= pageHeight[0]) {
                        pageHeight[0] = pageHeight[0] - item.height;
                    } else {
                        // 标题
                        if (item.questionType === 1) {
                            let height = pageHeight[0];
                            pageHeight[0] = 0;
                            pageHeight.shift();
                            lineTotal++;
                            item.marginTop = height;
                            pageHeight[0] = pageHeight[0] - item.height;
                        } else if (item.questionType === 2) {
                            // 选择题
                            if (item.questionSort.id === 2) {
                                let height = pageHeight[0];
                                // item.marginTop = 40 - (height % 40);
                                item.marginTop = (height % 40);
                                let reduceHeight = Math.floor(height / 40) * 40;
                                let nextHeight = item.height - reduceHeight;
                                pageHeight[0] = 0;
                                pageHeight.shift();
                                lineTotal++;
                                while (pageHeight[0] < nextHeight) {
                                    nextHeight = nextHeight - pageHeight[0];
                                    pageHeight[0] = 0;
                                    pageHeight.shift();
                                    lineTotal++;
                                }
                                pageHeight[0] = pageHeight[0] - nextHeight;
                            } else {
                                let mapDetail = item.detail.filter(value => !value.hasChildren);
                                let line = Math.ceil(mapDetail.length % 20);
                                let cutLineArr = []; // 切割成 20 份一个的小组
                                for (let i = 0; i < line;i++) {
                                    cutLineArr.push(item.detail.slice(i* 20, (i+1) * 20))
                                }
                                cutLineArr = cutLineArr.map(value => {
                                    return 60 + Math.max(... value.map(key=> key.questionOption.id)) * 40
                                });
                                let height = pageHeight[0];
                                let lineIndex = 0;
                                let compareHeight = height;
                                cutLineArr.every((line, lIndex) => {
                                    if (line > compareHeight) {
                                        lineIndex = lIndex;
                                        return false
                                    }
                                    compareHeight -= line;
                                    return true
                                });
                                // let lineHeight = cutLineArr[lineIndex];
                                let reduceHeight = cutLineArr.slice(0, lineIndex).reduce((a, b) => a + b);
                                let nextHeight = cutLineArr.slice(lineIndex, cutLineArr.length - 1).reduce((a, b) => a + b);
                                // item.marginTop = lineHeight - (height - reduceHeight);
                                item.marginTop = height - reduceHeight;
                                pageHeight[0] = 0;
                                pageHeight.shift();
                                lineTotal++;
                                while (pageHeight[0] < nextHeight) {
                                    nextHeight = nextHeight - pageHeight[0];
                                    pageHeight[0] = 0;
                                    pageHeight.shift();
                                    lineTotal++;
                                }
                                pageHeight[0] = pageHeight[0] - nextHeight;
                            }
                        } else if (item.questionType === 3) {
                            // 填空题
                            let height = pageHeight[0];
                            // item.marginTop = 60 - (height % 60);
                            item.marginTop = height % 60;
                            let reduceHeight = Math.floor(height / 60) * 60;
                            let nextHeight = item.height - reduceHeight;
                            pageHeight[0] = 0;
                            pageHeight.shift();
                            lineTotal++;
                            while (pageHeight[0] < nextHeight) {
                                nextHeight = nextHeight - pageHeight[0];
                                pageHeight[0] = 0;
                                pageHeight.shift();
                                lineTotal++;
                            }
                            pageHeight[0] = pageHeight[0] - nextHeight;
                        } else {
                            // 简答题
                            let height = pageHeight[0];
                            let nextHeight = item.height - height;
                            if (pageHeight[0] < 40) {
                                item.marginTop = pageHeight[0];
                                nextHeight = item.height;
                            } else {
                                console.log(pageHeight[0], item.height)
                                needAddLineIndex.push(lineTotal);
                            }
                            pageHeight[0] = 0;
                            pageHeight.shift();
                            lineTotal++;
                            while (pageHeight[0] < nextHeight) {
                                nextHeight = nextHeight - pageHeight[0];
                                pageHeight[0] = 0;
                                pageHeight.shift();
                                needAddLineIndex.push(lineTotal);
                                lineTotal++;
                            }
                            pageHeight[0] = pageHeight[0] - nextHeight;
                        }
                    }
                    if (pageHeight[0] === 0) {
                        pageHeight.shift();
                        lineTotal++;
                    }
                });
                this.needAddLineIndex = needAddLineIndex;
                this.questionShowList = list;
            },
            // 显示小题详情
            showQuestionDetail (question, index) {
                this.activeQuestion = question;
                this.activeQuestionIndex = index;
                this.detailDialog = true
            },
            // 增加标题
            addTitleQuestionTop (index) {
                this.questionShowList.splice(index, 0 ,{
                    order: this.questionShowList.length,
                    questionType: 1,
                    questionTypeName: '标题',
                    centerType: 1,
                    questionTitle: '这是一个标题',
                    height: 0,
                    marginTop: 0,
                    detail: []
                })
            },
            // 拆分题目
            splitQuestion (index) {
                let topDetailList = JSON.parse(JSON.stringify(this.questionShowList[this.activeQuestionIndex].detail.slice(0,index)));
                let detailList = JSON.parse(JSON.stringify(this.questionShowList[this.activeQuestionIndex].detail.slice(index,)));
                this.questionShowList[this.activeQuestionIndex].detail = topDetailList;
                let question = JSON.parse(JSON.stringify(this.questionShowList[this.activeQuestionIndex]))
                question.detail = detailList;
                this.questionShowList.splice(this.activeQuestionIndex + 1,0, question);
            },
            // 合并题目
            mergeLastQuestion (index) {
                if (this.questionShowList[index].questionType === 1) {
                    this.questionShowList.splice(index, 1);
                } else {
                    let list = JSON.parse(JSON.stringify(this.questionShowList.slice(0, index)));
                    let question = JSON.parse(JSON.stringify(this.questionShowList.slice(index, index + 1)));
                    let activeIndex = 0;
                    list.forEach((item, key) => {
                        if (item.questionType !== 1) {
                            activeIndex = key
                        }
                    });
                    if (this.questionShowList[activeIndex].questionType === 1) {
                        this.$notify.error({
                            title: '提示',
                            message: '已经是第一题了，无法合并',
                            offset: 50
                        });
                        return
                    }
                    this.questionShowList[activeIndex].detail = this.questionShowList[activeIndex].detail.concat(question[0].detail);
                    this.questionShowList.splice(index, 1);
                }
            },
            // 计算层级编号
            sumSmallOrder () {
                let order = 0;
                let smallOrder = 0;
                this.questionShowList.forEach(item => {
                    if (item.questionType !== 1) {
                        let smallOrderRight = 0;
                        item.detail.forEach(detail => {
                            order++;
                            detail.questionOrder = order;
                            if (detail.isMain) {
                                smallOrder++;
                                smallOrderRight = 0;
                                detail.questionSmallOrder = smallOrder;
                            } else {
                                if (detail.isNew) {
                                    smallOrderRight = 0;
                                }

                                if (!smallOrderRight) {
                                    smallOrder++
                                }
                                smallOrderRight++;
                                detail.questionSmallOrder = `${smallOrder}.${smallOrderRight}`
                            }
                            detail.questionShowOrder = String(this.titleInfo.numbering) === '2' ? detail.questionOrder : detail.questionSmallOrder;
                            // 用questionShowOrder替换html
                            if (this.isJudge) {
                                let arr = detail.html.split('').splice(0, detail.html.indexOf('</p>'))
                                let str = ''
                                if (arr.includes('_')) {
                                    if (arr.includes('（')) {
                                        arr.splice(0, arr.indexOf('（'))
                                    } else if(arr.includes(' (')) {
                                        arr.splice(0, arr.indexOf(' ('))
                                    }else {
                                        arr.splice(0, arr.indexOf('_'))
                                    }
                                    str = arr.join('')
                                }
                                detail.html = detail.html.substring(detail.html.indexOf('</p>') + 4)
                                detail.html = `<p>${detail.questionShowOrder + str}</p>` + detail.html
                            }
                            // detail.html = `<p>${detail.questionShowOrder}</p>`
                            // detail.questionOriginOrder = detail.questionShowOrder;
                        });
                        if (String(this.titleInfo.numbering) === '2') {
                            item.orderRange = `${item.detail[0].questionOrder}-${item.detail[item.detail.length - 1].questionOrder}`;
                        } else {
                            let left = item.detail[0] && item.detail[0].questionSmallOrder;
                            let right = item.detail[item.detail.length - 1] && item.detail[item.detail.length - 1].questionSmallOrder;
                            item.orderRange = `${String(left).split('.')[0]}-${String(right).split('.')[0]}`;
                        }
                    }
                })
            },
            // 获取组卷详情
            getConstructDetail () {
                this.isLoading = true;
                this.$https.get('/api/tk/composedPaper/detail', {
                    params: {
                        id: this.constructId
                    }
                }).then(response => {
                    if (response.code === 0) {
                        this.constructInfo = response.data;
                        if (!this.constructInfo.detail) {
                            this.isJudge = true
                        } else {
                            this.isJudge = false
                        }
                        if (this.constructInfo.detail && JSON.parse(this.constructInfo.detail).isNew) {
                            this.isLoading = false;
                            let list = JSON.parse(this.constructInfo.detail || '{}' ).questionList || [];
                            this.titleInfo = JSON.parse(this.constructInfo.detail || '{}' ).titleInfo;
                            this.questionShowList = list.map(item => {
                                item.marginTop = item.marginTop || 0;
                                item.detail.forEach(value => {
                                    value.questionSmallOrder = value.questionSmallOrder || value.questionOrder || '';
                                    value.questionShowOrder = String(this.titleInfo.numbering) === '2' ? value.questionOrder : value.questionSmallOrder;
                                    value.questionOriginOrder = value.questionShowOrder;
                                    value.html = value.html || `<p>${value.questionShowOrder}</p>`
                                });
                                if (item.questionType !== 1) {
                                    item.orderRange = `${item.detail[0].questionOrder}-${item.detail[item.detail.length - 1].questionOrder}`;
                                }
                                return item
                            });
                            if (!this.titleInfo.paperFormat) {
                                this.titleInfo.paperFormat = this.titleInfo.paperSize ? 'A4' : 'A3';
                            }
                            this.titleInfo.numbering = this.titleInfo.numbering || '1';
                            this.isLoading = false;
                        } else {
                            if (this.constructInfo.paperId) {
                                this.getPaperDetail();
                            } else {
                                this.$notify.error({
                                    title: '提示',
                                    message: '缺少试卷信息，请检查！',
                                    offset: 50
                                });
                                this.isLoading = false;
                            }
                        }
                    }
                }).catch(error =>{
                    this.isLoading = false;
                    this.$errorLog(error)
                })
            },
            // 获取试卷详情
            getPaperDetail () {
                this.$https.get('/api/tk/question/getAll', {
                    params: {
                        paperId: this.constructInfo.paperId
                    }
                }).then(response => {
                    if (response.code === 0) {
                        this.titleInfo = JSON.parse(JSON.stringify({
                            name: this.constructInfo.name, // 试卷名
                            paperFormat: 'A4', // 纸张格式 A4 A3 16K 8K
                            paperSize:true, // 是否A4 或者 16k
                            isBinding:false, // 是否装订
                            sendTime: '', // 答案发送时间
                            numbering: '1', // 编号顺序  层级编号 1 顺序编号 2
                            isOnlineCorrecting: false // 是否在线批改
                        }));
                        let data = JSON.parse(JSON.stringify(response.data));
                        let smallOrder = 0;
                        let rightOrder= 0;
                        data.forEach(a => {
                            a.valueList = [];
                            a.value.forEach((b) => {
                                if (b.subQuestions.length === 1) {
                                    smallOrder++;
                                    rightOrder = 0;
                                    b.subQuestions[0].questionSmallOrder = smallOrder;
                                    b.subQuestions[0].isMain = true;
                                    b.subQuestions[0].isNew = true;
                                    a.valueList.push(b.subQuestions[0]);
                                } else {
                                    if (!a.valueList.length || a.valueList[a.valueList.length - 1].isMain) {
                                        smallOrder++;
                                    }
                                    b.subQuestions.forEach((c, index) => {
                                        rightOrder++;
                                        c.isNew = index === 0;
                                        c.isMain = false;
                                        c.questionSmallOrder = `${smallOrder}.${rightOrder}`;
                                        a.valueList.push(c);
                                    })
                                }
                            })
                        });
                        let list = [];
                        let order = 0;
                        data.forEach((item) => {
                            list.push({
                                order: list.length,
                                questionType: 1,
                                questionTypeName: '标题',
                                centerType: 1,
                                questionTitle: item.title,
                                height: 0,
                                marginTop: 0,
                                detail: []
                            });
                            let obj = {
                                orderRange: '',
                                order: list.length,
                                questionType: item.name === '选择题' ? 2 :
                                item.name === '填空题' ? 3 : 4,
                                questionTypeName: item.name,
                                height: 0,
                                marginTop: 0,
                                questionOption: {name:'4项 (A|B|C|D)',id:4, count: 4},
                                questionBackground: {name:'空白',id:1},
                                questionBlankWidth: {name:'1/4 行宽',id:0.25},
                                questionSort: {name:'横排',id:2},
                                detail: []
                            };
                            item.valueList.forEach((detail) => {
                                order++;
                                let detailObj = {
                                    multipleChoice: item.multipleChoice || false,
                                    isMain: detail.isMain,
                                    isNew: detail.isNew,
                                    questionOrder: order,
                                    questionSmallOrder: detail.questionSmallOrder || order,
                                    questionValue: Number(detail.score),
                                    questionOption: {name:'4项 (A|B|C|D)',id:4, count: 4},
                                    questionBackground: {name:'空白',id:1},
                                    questionBlankWidth: {name:'1/4 行宽',id:0.25},
                                    questionSort: {name:'横排',id:2},
                                };
                                detailObj.questionShowOrder = String(this.titleInfo.numbering) === '2' ? detailObj.questionOrder : detailObj.questionSmallOrder;
                                detailObj.questionOriginOrder = detailObj.questionShowOrder;
                                detailObj.html= `<p>${detailObj.questionShowOrder}</p>`;
                                obj.detail.push(detailObj)
                            });
                            obj.orderRange = `${obj.detail[0].questionOrder}-${obj.detail[obj.detail.length - 1].questionOrder}`;
                            list.push(obj);
                        });
                        // console.log(data);
                        // this.questionShowList = JSON.parse(this.constructInfo.detail).questionList.map(item => {
                        //     item.marginTop = 0;
                        //     item.detail.forEach(value => {
                        //         value.html = value.html || `<p>${value.questionOrder}</p>`
                        //     });
                        //     return item
                        // });
                        this.questionShowList = list;
                    }
                    this.isLoading = false;
                }).catch(error =>{
                    this.isLoading = false;
                    this.$errorLog(error)
                })
            },
            // 转文件
            dataURLtoFile (dataUrl, filename = 'file') {
                let arr = dataUrl.split(',');
                let mime = arr[0].match(/:(.*?);/)[1];
                let suffix = mime.split('/')[1];
                let bstr = atob(arr[1]);
                let n = bstr.length;
                let u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], `${filename}.${suffix}`, { type: mime })
            },
            // sumSetPieceNum 计算定位块数量
            sumSetPieceNum () {
                const element = document.getElementById('left').children[0];
                const height = element.offsetHeight;
                const transform = element.style.transform;
                element.style.transform = 'none';
                return  html2canvas(element.children[0], {
                    scale: 1,
                    useCORS:true,
                    backgroundColor: null,
                    width:20,
                    height:height,
                    dpi: window.devicePixelRatio,
                    allowTaint:false
                }).then(canvas => {
                    element.style.transform = transform;
                    canvas.style.width = 'auto';
                    canvas.style.height = 'auto';
                    const ctx = canvas.getContext("2d");
                    const width = canvas.width;
                    const height = canvas.height;
                    let data = ctx.getImageData(0, 0, width, height).data;
                    let obj = {};
                    for (let k = 0; k < height; k++) {
                        let list = [];
                        for (let l = 0; l < width; l++) {
                            if (l < 5 || l > 15) {
                                continue
                            }
                            const i = 4 * (k * width + l);
                            const value = data[i] + data[i + 1] + data[i + 2];
                            list.push(value);
                        }
                        obj[k+1] = list.reduce((x, y) => x + y);
                    }
                    return obj
                });
            },
            // 试卷保存
            async savePaper () {
                // let data = await this.sumSetPieceNum();
                // let list = JSON.parse(JSON.stringify(this.lineTipShowArr));
                // let isAgree = true;
                // list.every(item => {
                //     if (data[item] === 0) {
                //         isAgree = false;
                //         return false;
                //     }
                //     return true;
                // });
                // if (!isAgree) {
                //     this.$notify.error({
                //         title: '提示',
                //         message: '试卷分割线阻挡定位块，请检查！',
                //         offset: 50
                //     });
                //     return;
                // }
                // let pagePieceNumList = [];
                // let pieceList = [];
                // for (let key in data) {
                //     if (data[key] === 0) {
                //         pieceList.push(data[key])
                //     }
                //     if (Number(key) === list[0]) {
                //         pagePieceNumList.push(pieceList);
                //         pieceList = [];
                //         list.shift();
                //     }
                // }
                // let pagePieceNum = pagePieceNumList.map((item, index) => {
                //     return {
                //         page: index + 1,
                //         num: Math.floor(item.length / 12)
                //     }
                // });
                // console.log(pagePieceNum);
                // return
                this.isLoading = true;
                if (this.titleInfo.sendTime) {
                    this.titleInfo.sendTime = this.$format.formatTime(this.titleInfo.sendTime, 'yyyy-MM-dd HH:mm:ss')
                }
                let detail = JSON.stringify({
                    questionList: this.questionShowList,
                    titleInfo: this.titleInfo,
                    isNew: true,
                    paperSize: this.lineTipArr.length
                });
                this.constructInfo.detail = detail;
                this.constructInfo.name = this.titleInfo.name;
                this.$https.post('/api/tk/composedPaper/add', this.constructInfo).then(response => {
                    if (response.code === 0) {
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                    this.isLoading = false;
                }).catch(error =>{
                    this.isLoading = false;
                    this.$errorLog(error)
                })
            },
            // 试卷下载
            downPaper() {
                this.clearCircle()
                this.isLoading = true;
                const element = document.getElementById('left').children[0];
                const width = element.offsetWidth;
                const height = element.offsetHeight;
                const transform = element.style.transform;
                // const scale = window.devicePixelRatio * 2;
                element.style.transform = 'none';
                html2canvas(element.children[0], {
                    scale: 2,
                    useCORS:true,
                    backgroundColor: null,
                    width:width,
                    height:height,
                    dpi: window.devicePixelRatio,
                    allowTaint:false
                }).then(canvas => {
                    canvas.style.width = 'auto';
                    canvas.style.height = 'auto';
                    element.style.transform = transform;
                    let data = canvas.toDataURL('image/jpg', 1.0);
                    let blob = this.dataURLtoFile(data, this.titleInfo.name);
                    this.requestPdfUrl(blob);
                });
            },
            requestPdfUrl (blob) {
                let points = this.lineTipShowArr.map((item, index) => {
                    return {
                        height: item * 2,
                        line: this.needAddLineIndex.includes(index)
                    }
                });
                points.pop();
                let formData = new FormData();
                formData.append('file', blob);
                formData.append('pageSize ', this.titleInfo.paperFormat);
                formData.append('isBinding', this.titleInfo.isBinding);
                formData.append('id', this.constructInfo.id);
                formData.append('isOnline', this.titleInfo.isOnlineCorrecting);
                formData.append('cutPoints', JSON.stringify(points));
                formData.append('name', this.titleInfo.name);
                this.$https.post('/api/tk/composedPaper/img2pdf', formData).then(response => {
                    if (response.code === 0) {
                        window.open(response.data)
                    }
                    this.isLoading = false;
                }).catch(error =>{
                    this.isLoading = false;
                    this.$errorLog(error)
                })
            },
            // 清除试卷
            clearCircle () {
                let element = document.getElementsByClassName('ck-widget__type-around__button')
                for (let i = 0; i < element.length; i ++) {
                    element[i].style.display='none'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .intelligent_edit{
        height: 100%;
        overflow: hidden;
        font-family: msyh;
        line-height: 1;
        .intelligent_edit_container{
            height: calc(100% - 67px);
            background: #F6F6F6;
            /*overflow: auto;*/
            box-sizing: border-box;
            padding: 30px 0;
            white-space: nowrap;
            text-align: center;
            .edit_left{
                /*width: 610px;*/
                width: 800px;
                height: 100%;
                overflow-x: auto;
                overflow-y: auto;
                box-sizing: border-box;
                display: inline-block;
                vertical-align: middle;
                position: relative;
                padding-bottom: 20px;
                padding-left: 20px;
                .page_line{
                    position: absolute;
                    width: 778px;
                    left: 0;
                    color: red;
                    font-size: 16px;
                    border-bottom: 1px dashed red;
                    span{
                        position: absolute;
                        left: 0;
                        bottom: 5px;
                    }
                }
                .edit_left_paper{
                    /*width: 1180px;*/
                    width: 1054px;
                    position: absolute;
                    left: 20px;
                    top: 0;
                    right: 0;
                    margin-bottom: 20px;
                    box-shadow: rgba(7, 0, 2, 0.04) 0 0 8px 0;
                    -webkit-transform: scale(.7);
                    transform: scale(.7);
                    -webkit-transform-origin: 0 0;
                    transform-origin: 0 0;
                    //transform: scale(.5) translate(-50%, -50%);
                    .paper_container{
                        min-height: 1348px;
                        background: white;
                        text-align: left;
                    }
                }
            }
            .edit_right{
                height: 100%;
                width: 520px;
                display: inline-block;
                vertical-align: middle;
                overflow-x: hidden;
                overflow-y: auto;
                padding-bottom: 20px;
                box-sizing: border-box;
                margin-left: 10px;
            }
        }
        .intelligent_edit_foot{
            height: 67px;
            background: rgba(255,255,255,1);
            box-shadow: 0 0 20px rgba(7,0,2,0.15);
            position: relative;
            bottom: 0;
            z-index: 2;
            display: flex;
            align-items: center;
            justify-content: center;
            .edit_foot{
                width: 1210px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .btn_bar{
                    display: flex;
                    align-items: center;
                    .btn{
                        width: 98px;
                        height: 36px;
                        border-radius: 3px;
                        border: none;
                        font-size: 16px;
                        float: right;
                        vertical-align: middle;
                        margin-left: 15px;
                        background: rgba(0,144,247,1);
                        box-shadow: 0 0 8px 0 rgba(8,0,2,0.05);
                        color: rgba(255,255,255,1);
                        &.download{
                            background: rgba(255,168,0,1);
                        }
                    }
                }
            }
        }
    }
</style>
